import { DASHBOARD_ROUTE_PATHS } from './dashboard/config';

export const HOME_ROUTE_PATHS = {
  ...DASHBOARD_ROUTE_PATHS,
};

export default { RoutePaths: HOME_ROUTE_PATHS };
